const MAX_RESULT_ID_LENGTH = 128

export const isResultId = (value) => typeof value === 'string'
  && value.length > 0
  && value.length <= MAX_RESULT_ID_LENGTH

/**
 * Whether a server settlement earns a coin: settled, delivered, costly and a positive whole
 * number of AI credits, with a result id to key it by. Nothing else (tool counts, text,
 * local success) ever counts.
 * @param {Object|null} settlement {resultId, settlement, outcome, costly, aiCredits, monthTotal}
 * @returns {boolean}
 */
export const isCoinWorthySettlement = (settlement) => Boolean(
  settlement
  && typeof settlement === 'object'
  && isResultId(settlement.resultId)
  && settlement.settlement === 'settled'
  && settlement.outcome === 'delivered'
  && settlement.costly === true
  && Number.isInteger(settlement.aiCredits)
  && settlement.aiCredits > 0,
)

/**
 * The coin to render for a settlement, or null when it earns none.
 * @param {Object|null} settlement
 * @returns {{resultId: string, aiCredits: number, monthTotal: number|null}|null}
 */
export const toAiCreditCoin = (settlement) => {
  if (!isCoinWorthySettlement(settlement)) return null
  return {
    resultId: settlement.resultId,
    aiCredits: settlement.aiCredits,
    monthTotal: Number.isInteger(settlement.monthTotal) ? settlement.monthTotal : null,
  }
}

export const aiCreditCoinKey = (source, presentationId) => `${source}:${presentationId}`
